import { labelids } from "../../assets/data/TkExplanationProperty";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const noOwnerReasonList = [
  {
    label: "共済契約の申込み連絡",
    value: { path: "/SCRC030001", jobType: "JOB-73" },
  },
  {
    label: "共済契約の申込み",
    value: { path: "/SCRC030102", jobType: "JOB-01", search: "CONTRACTOR" },
  },
  {
    label: "共済契約の解除(なくなった者)",
    value: { path: "/SCRC050106", jobType: "JOB-02", search: "CONTRACTOR" },
  },
  {
    label: "共済契約の解除(中退共)",
    value: { path: "/SCRC050110", jobType: "JOB-03", search: "CONTRACTOR" },
  },
  {
    label: "共済契約の解除（同意解除）",
    value: { path: "/SCRC050113", jobType: "JOB-04", search: "CONTRACTOR" },
  },
  {
    label: "名称等の変更(契約者)",
    value: { path: "/SCRC040002", jobType: "JOB-05", search: "CONTRACTOR" },
  },
  {
    label: "証書再交付",
    value: { path: "/SCRC040002", jobType: "JOB-06", search: "CONTRACTOR" },
  },
  {
    label: "調整額の申請",
    value: { path: "/SCRC040004", jobType: "JOB-07", search: "CONTRACTOR" },
  },
  {
    label: "従業状況更新",
    value: { path: "/SCRC060112", jobType: "JOB-10", search: "CONTRACTOR" },
  },
  {
    label: "掛金届",
    value: { path: "/SCRW110004", jobType: "JOB-11", search: "CONTRACTOR" },
  },
  {
    label: "期限延長",
    value: { path: "/SCRC080009", jobType: "JOB-12", search: "CONTRACTOR" },
  },
  {
    label: "施設等の新設",
    value: { path: "/SCRC050101", jobType: "JOB-15", search: "CONTRACTOR" },
  },
  {
    label: "契約の部分解除",
    value: { path: "/SCRC050125", jobType: "JOB-16", search: "CONTRACTOR" },
  },
  {
    label: "施設種類の変更",
    value: { path: "/SCRC050017", jobType: "JOB-17", search: "CONTRACTOR" },
  },
  {
    label: "施設等の廃止",
    value: { path: "/SCRC050120", jobType: "JOB-18", search: "CONTRACTOR" },
  },
  {
    label: "名称等の変更(施設)",
    value: { path: "/SCRC050017", jobType: "JOB-19", search: "CONTRACTOR" },
  },
  {
    label: "特定職員数等の変更",
    value: { path: "/SCRC050029", jobType: "JOB-20", search: "CONTRACTOR" },
  },
  {
    label: "新規職員の非加入",
    value: { path: "/SCRC050018", jobType: "JOB-21", search: "CONTRACTOR" },
  },
  {
    label: "非加入の取下げ",
    value: { path: "/SCRC050019", jobType: "JOB-22", search: "CONTRACTOR" },
  },
  {
    label: "職員の加入",
    value: { path: "/SCRC060108", jobType: "JOB-23", search: "CONTRACTOR" },
  },
  {
    label: "異動届",
    value: { path: "/SCRC060013", jobType: "JOB-28", search: "CONTRACTOR" },
  },
  {
    label: "継続異動（加入）",
    value: { path: "/SCRC060108", jobType: "JOB-23", search: "CONTRACTOR" },
  },
  {
    label: "退職届",
    value: { path: "/SCRC060118", jobType: "JOB-32", search: "CONTRACTOR" },
  },
  {
    label: "継続異動（退職）",
    value: { path: "/SCRC060118", jobType: "JOB-33", search: "CONTRACTOR" },
  },
  {
    label: "退職届の取下げ",
    value: { path: "/SCRC060031", jobType: "JOB-34", search: "CONTRACTOR" },
  },
  {
    label: "退職金請求",
    value: { path: "/SCRR411102", jobType: "JOB-35", search: "RETIREE" },
  },
  {
    label: "合算届（退職）",
    value: { path: "/SCRR411102", jobType: "JOB-36", search: "RETIREE" },
  },
  {
    label: "退職金請求の取下げ",
    value: { path: "/SCRR410030", jobType: "JOB-37", search: "RETIREE" },
  },
  {
    label: "合算退職の取下げ",
    value: { path: "/SCRR411102", jobType: "JOB-38", search: "RETIREE" },
  },
  {
    label: "振込先金融機関の変更",
    value: { path: "/SCRR410028", jobType: "JOB-39", search: "RETIREE" },
  },
  {
    label: "受領者変更（連絡）",
    value: { path: "/SCRR411119", jobType: "JOB-40", search: "RETIREE" },
  },
  {
    label: "受領者変更（請求）",
    value: { path: "/SCRR410003", jobType: "JOB-41", search: "RETIREE" },
  },
  {
    label: "返戻請求依頼",
    value: { path: "/SCRC070105", jobType: "JOB-75", search: "CONTRACTOR" },
  },
];

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    keyword: "info",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLW110005_01,
    explanatoryTextRule: "\\n",
  },
  {
    title: "申請・届出選択",
    keyword: "noOwnerReason",
    type: "selectForm",
    selectPropsList: noOwnerReasonList,
    requiredIcon: true,
  },

  {
    title: "契約者（法人）名",
    keyword: "contractorName",
    type: "nodeInLine",
    requiredIcon: true,
    showLine: false,
  },
  {
    title: "退職者",
    keyword: "retireeName",
    type: "nodeInLine",
    disabled: true,
    requiredIcon: true,
    showLine: false,
  },
];

const schema = {
  noOwnerReason: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
};

export { fakeTableList, schema };
